import './Footer.css';
import React from 'react';

function Footer() {
  return (
    <div className="footer" data-role="footer" data-position="fixed">
      <p className="copy">
        All right Reserved.
        <br />
        Created with &#x2615; in Morocco!
      </p>
    </div>
  );
}

export default Footer;
